export default class EventList {
	self = this;

	constructor() {
		this.self.filters = {
			country: '',
			distance: '',
			month: ''
		};
	}

	init() {
		if ($('.event-list').length > 0) {
			this.initFilters();
		}
	}

	searchEvents(filters) {
		const dis = this;
		const preloader = $('.event-list').find('.event-list__preloader');
		const empty = $('.event-list').find('.event-list__empty');

		preloader.removeClass('hidden');
		empty.addClass('hidden');

		$('.event-list__list .event-item').hide();

		let count = 0;

		const normalizedFilters = this.normalizeFilters(filters);
		setTimeout(function () {
			$('.event-list__list .event-item').each(function () {
				const $item = $(this);
				const item = dis.normalizeItemData($item);
				if (
					(normalizedFilters.country === '' || item.country === normalizedFilters.country) &&
					(normalizedFilters.distance === '' || item.distances.includes(normalizedFilters.distance)) &&
					(
						normalizedFilters.month === '' ||
						item.startMonth === normalizedFilters.month ||
						item.endMonth === normalizedFilters.month
					)
				) {
					count++;
					$(this).show();
				}
			});
			preloader.addClass('hidden');

			if (count > 0) {
				empty.addClass('hidden');
			} else {
				empty.removeClass('hidden');
			}
		}, 500);
	}

	normalizeFilters(filters) {
		return {
			...filters,
			country: filters.country !== '' ? parseInt(filters.country, 10) : '',
			month: filters.month !== '' ? parseInt(filters.month, 10) : ''
		};
	}

	normalizeItemData($item) {
		const data = $item.data();

		return {
			...data,
			country: data.country !== undefined ? parseInt(data.country, 10) : null,
			startMonth: data.startMonth !== undefined ? parseInt(data.startMonth, 10) : null,
			endMonth: data.endMonth !== undefined ? parseInt(data.endMonth, 10) : null,
			distances: data.distances
				? data.distances.toString().split(',')
				: []
		};
	}

	initFilters() {
		const self = this.self;
		const filterParent = $('.event-list').find('.event-list__filters');

		filterParent.find('select').on('change', function () {
			const name = $(this).attr('name');
			const value = $(this).val();
			self.filters[name] = value;
			self.searchEvents(self.filters);
		});
	}
}
